import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class EdificacaoDBService extends DatabaseService{
    override classname: string = 'EdificacaoDBService';
    override table = 'edificacao';

    protected override migration: number = 1;

    override indices = [
        {name: "by_id", field: "id", unique: false, multiEntry: false},
        {name: "by_estabelecimento", field: "estabelecimento_id", unique: false, multiEntry: false},
        {name: "by_sinc", field: "sinc", unique: false, multiEntry: false}
    ];
}
